module.exports = __webpack_public_path__ + "static/media/SIMPeeL.2cb158b6.png";